import httpService from 'services/http/http.service';
import ApiUrl from 'enum/api-url.enum';

function getSliderTimer(params) {
  let url = ApiUrl.SLIDERTIMER;
  if (params) {
    const queryParams = Object.keys(params)
      .map(key => `${key}=${encodeURIComponent(params[key])}`)
      .join('&');
    url += `?${queryParams}`;
  }
  return httpService.get(url);
}

const obj = { getSliderTimer };

export default obj;
